import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { RegisterApiResponse } from "@core/models/api.response";
import { RegisterDTO } from "@core/models/dto.models";
import { RegistrationState } from "@core/models/registration.interface";
import { IntentTypes } from "@shared/enums";
import { getIdentificationDetail } from "@shared/utils/helper_functions";
import { Observable, of } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class RegisterService {
  constructor(private http: HttpClient) {}

  register(registerData: RegistrationState): Observable<RegisterApiResponse> {
    if (!registerData.registered) {
      const data = registerData.data;

      let registerDTO: RegisterDTO = {
        termsAccepted: data.termsAccepted,
        marketingConsent: data.marketingConsent,
        accountCredentials: data.accountCredentials,
        mobile: { otp: data.mobile.otp },
        intent: data.intent,
        email: data.email,
        platform: data.platform,
        guid: data.guid ?? "",
      };

      if (registerDTO.intent !== IntentTypes.partial)
        registerDTO.mobile.number = data.mobile.number;

      if (registerDTO.intent === IntentTypes.new) {
        registerDTO["personalInfo"] = data.personalInfo;
        registerDTO["identificationDocument"] = getIdentificationDetail(
          data.identificationDocument
        );
      }

      return this.http.post<RegisterApiResponse>(
        `${environment.apiUri}/profile/register`,
        registerDTO
      );
    }

    return of({} as RegisterApiResponse);
  }
}
